import { useState } from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TablePagination,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { WorkItemsTable } from './WorkItemsTable';
import { ModalActionInfo } from './ModalActionInfo';
import { useStyles } from '../../../styles';

interface WorkItemsModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  itemsCount: number;
  badgeLabel: string;
  description: string;
  priority: 'High' | 'Medium' | 'Low';
  links: string[];
}

const ROWS_PER_PAGE = 10;

export function WorkItemsModal({
  isOpen,
  onClose,
  title,
  itemsCount,
  badgeLabel,
  description,
  priority,
  links = [],
}: WorkItemsModalProps) {
  const classes = useStyles();

  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(ROWS_PER_PAGE);

  const onPageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => {
    event?.preventDefault();
    setCurrentPage(page);
  };

  const onRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    event.preventDefault();
    setCurrentPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const paginatedLinks = links.slice(
    currentPage * rowsPerPage,
    (currentPage + 1) * rowsPerPage,
  );
  return (
    <Dialog
      open={isOpen}
      onClose={() => onClose()}
      maxWidth="md"
      fullWidth
      aria-labelledby="work-items-dialog-title"
      classes={{ paper: classes.qeThemeScope }}
    >
      <DialogTitle id="work-items-dialog-title" disableTypography>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Work Items</Typography>
          <IconButton aria-label="close" onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <ModalActionInfo
          title={title}
          itemsCount={itemsCount}
          badgeLabel={badgeLabel || ''}
          description={description || ''}
          priority={priority || 'High'}
        />

        <Grid xs={12} className="mt-2">
          <WorkItemsTable items={paginatedLinks} />
        </Grid>
      </DialogContent>

      <DialogActions>
        <Typography
          variant="body2"
          color="textSecondary"
          className={classes.workItemsModalTotalText}
        >
          <TablePagination
            component="div"
            rowsPerPage={rowsPerPage}
            page={currentPage}
            count={links.length}
            SelectProps={{ disabled: links.length <= ROWS_PER_PAGE }}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
          />
        </Typography>
      </DialogActions>
    </Dialog>
  );
}
